'use strict'
//a stream that errors immediately.
module.exports = function error (err) {
  return function (abort, cb) {
    cb(err)
  }
}




//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sources/error.js
// module id = 390
// module chunks = 0